(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ZalgoPromise", [], factory);
	else if(typeof exports === 'object')
		exports["ZalgoPromise"] = factory();
	else
		root["ZalgoPromise"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 